module.exports = __webpack_public_path__ + "static/media/speech_08.2aedb6a9.png";